var render, staticRenderFns
import script from "./TCPCModal.vue?vue&type=script&lang=js"
export * from "./TCPCModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9dbf73c')) {
      api.createRecord('f9dbf73c', component.options)
    } else {
      api.reload('f9dbf73c', component.options)
    }
    
  }
}
component.options.__file = "src/components/snippets/TCPCModal.vue"
export default component.exports